
<div  class="container-fluid g-0">
  <!-- MAIN -->
  <!-- MAIN CONTENT FOR ACESS PAGE -->
  @if(IsLoginPageActive()){
    <router-outlet style="flex-grow: 1;"></router-outlet>
  }

  <!-- MAIN CONTENT FOR OPERATION PAGE-->
  @if(!IsLoginPageActive()){
    <main>

        <!-- DISPLAY CONTENT OF OPERATION PAGES -->
        <!-- DESKTOP -->
        <div class="display-area p-0" [ngClass]="{'display-area-shrink': sideNavStatus}">
            <router-outlet   style="flex-grow: 1;"></router-outlet>
        </div>

    </main>
  }

  <!-- FOOTER - DISPLAYED IN EVERY PAGE  -->
  <app-footer></app-footer>

</div>
